module.exports = __webpack_public_path__ + "media/images/flags/32/US-Virgin-Islands-b3d268424afac8d8be2e88f2b5e06e1d.png";